import { sendToMixpanel } from '..';
import { FAA_LANDING_PAGE_MODULE } from './modules';

export const trackViewMore = (): void => {
  sendToMixpanel('Click FAA Landing Page Module', {
    siteSection: 'Agents',
    module: FAA_LANDING_PAGE_MODULE.CONTENT_CAROUSEL_GUIDES,
    interactionType: 'View More',
  });
};

export default trackViewMore;
